import { createRequestTypes } from '../../utils';

export const NEW_LABEL_REVIEW_WIZARD = createRequestTypes('labelReviewWizard/NEW_LABEL_REVIEW_WIZARD');
export const EDIT_LABEL_REVIEW_WIZARD = createRequestTypes('labelReviewWizard/EDIT_LABEL_REVIEW_WIZARD');
export const LOAD_LABEL_REVIEW_DATA = 'labelReviewWizard/LOAD_LABEL_REVIEW_DATA';
export const UPDATE_LABEL_REVIEW = 'labelReviewWizard/UPDATE_LABEL_REVIEW';
export const SAVE_BUTTON_CLICKED = 'labelReviewWizard/SAVE_BUTTON_CLICKED';
